<template>
  <v-container>
    <!-- Snackbar -->
    <SnackbarMessage ref="snackbar" />
    <!-- Pantalla de carga -->
    <LoadingLayout v-if="isUpdatingMP">
      <CircularLoading>
        Actualizando datos de Mercado Pago
      </CircularLoading>
    </LoadingLayout>
    <!-- Contenido -->
    <v-row v-else no-gutters>
      <v-col cols="12" class="deltia-card pa-2">
        <!-- Subtítulo -->
        <h3 class="mb-3">
          Cuenta de Mercado Pago
        </h3>
        <v-btn rounded depressed color="secondary" @click="connectMercadoPago">
          Conectar con Mercado Pago
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from "qs";
import axios from "axios";
import SnackbarMessage from "@/components/SnackbarMessage";
import LoadingLayout from "@/layouts/LoadingLayout";
import CircularLoading from "@/components/Loading/Circular";
import UserServices from "@/services/UsersServices";

export default {
  name: "MercadoPagoView",
  components: {
    SnackbarMessage,
    CircularLoading,
    LoadingLayout
  },
  data() {
    return {
      isUpdatingMP: false
    };
  },
  mounted: async function() {
    if (this.$route.query.code) {
      this.isUpdatingMP = true;

      try {
        const response = await axios({
          method: "post",
          url: "https://api.mercadopago.com/oauth/token",
          data: qs.stringify({
            client_secret: process.env.VUE_APP_MP_CLIENT_SECRET,
            code: this.$route.query.code,
            redirect_uri: window.location.origin + this.$route.path,
            grant_type: "authorization_code"
          }),
          headers: {
            "content-type": "application/x-www-form-urlencoded"
          }
        });

        // Enviar al servidor
        await UserServices.updateMercadoPagoData(response.data);

        // Redirigir al usuario
        window.location.href = window.location.origin + "/settings";
      } catch (err) {
        this.isUpdatingMP = false;
        this.$refs.snackbar.showError(err.message);
      }
    }
  },
  methods: {
    connectMercadoPago() {
      // Obtener datos de la petición
      const appId = process.env.VUE_APP_MP_APP_ID;
      const redirectUri = window.location.origin + this.$route.path;

      const finalUrl = `https://auth.mercadopago.com.mx/authorization?client_id=${appId}&response_type=code&platform_id=mp&redirect_uri=${redirectUri}`;

      window.location.href = finalUrl;
    }
  }
};
</script>
